export enum ArticlePurchaseInformationObjectType {
  ARTICLE_PURCHASE_PRICE = 'ARTICLE_PURCHASE_PRICE',
  SUPPLIER_ORDER = 'SUPPLIER_ORDER',
  INCOMMING_DELIVERY_NOTE = 'INCOMMING_DELIVERY_NOTE',
}
